import {
    EDITING_GUARANTOR,
    EDIT_GUARANTOR_LEAVE
} from './AdditionalGuarantor.actions';

const initialState = {
    guarantors: null,
    uid: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case EDITING_GUARANTOR:
            return {
                ...state,
                guarantors: action.guarantors,
                uid: action.uid
            };
        case EDIT_GUARANTOR_LEAVE:
            return initialState;
        default:
            return state;
    }
}
